<!-- removeItemModal -->
<ng-template #template let-modal>
    <div class="modal-content">
        <div class="modal-header border-bottom">
            <div class="fs-15 px-2">
                <h4 class="mb-0">
                    {{'heading-title.reassign-trip' | translate}}
                </h4>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close"
                (click)="closeModal()"></button>
        </div>
        <div class="modal-body">
            <p class="mb-4 opacity-50 font-weight-medium px-2">
                {{'label-title.select-driver-assign-method-menual-or-nearest' |
                translate }}</p>
            <div class="row px-2">
                <div class="col-12">
                    <div class="form-check form-check-dark">
                        <div class="mb-4">
                            <input type="checkbox" id="formCheck12"
                                [checked]="isManually == helper.bookingDriverAssignEnum.NEAREST_DRIVER"
                                class="form-check-input rounded-circle"
                                (click)="onDriverAssignChange(helper.bookingDriverAssignEnum.NEAREST_DRIVER, $event);"><label
                                for="formCheck12" class="form-check-label">
                                {{'label-title.assign-nearest-driver' | translate}}</label>
                        </div>
                        <div class="mb-3">
                            <input type="checkbox" id="formCheck13"
                                [checked]="isManually == helper.bookingDriverAssignEnum.MANUALLY"
                                class="form-check-input rounded-circle"
                                (click)="onDriverAssignChange(helper.bookingDriverAssignEnum.MANUALLY , $event);"><label
                                for="formCheck13" class="form-check-label">
                                {{'label-title.manually-assign-driver' | translate}}</label>
                        </div>
                        @if(isManually == helper.bookingDriverAssignEnum.MANUALLY){
                        <ng-select id="driver-map-city" appearance="outline" [(ngModel)]="driverId" #agreeSelect
                            [searchable]="true" placeholder="{{ 'label-title.select-driver' | translate }}"
                            [clearable]="false">
                            @for(provider of nearestProvider ; track $index){
                            <ng-option [value]="provider._id">{{provider.firstName}}
                                {{provider.lastName}}</ng-option>
                            }
                        </ng-select>
                        @if( isSubmitted && !driverId){
                        <div class="invalid-message">
                            {{'label-title.driver' | translate}} {{'label-title.is-required'
                            |
                            translate}}
                        </div>
                        }
                        }
                    </div>
                </div>
            </div>
            <div class="d-flex gap-2 justify-content-end mt-4 mb-2">
                <button id="delete-details"
                    class="btn w-sm btn-secondary btn-load d-flex align-items-center justify-content-center"
                    style="overflow: unset;" [ngClass]="{'pointer-events-none':helper.showBtnLoader[1]}"
                    (click)="onAssign()">
                    <span class="d-flex align-items-center">
                        @if (helper.showBtnLoader[1]) {
                        <span class="spinner-border flex-shrink-0" role="status">
                            <span class="visually-hidden"></span>
                        </span>
                        } @else {
                        <span class="flex-grow-1" [ngClass]="{'ms-2':helper.showBtnLoader[1]}">
                            {{'button-title.assign' | translate | titlecase}}
                        </span>
                        }
                    </span>
                </button>
            </div>
        </div>
    </div>
</ng-template>
